import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import moment from "moment";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

/**
 * Item date overrides: { "YYYY-MM-DD": { pickup: string[], delivery: string[] } }.
 * Empty arrays block the date for that fulfillment type; we currently always block both.
 */
export default function ProductSpecialHours(props) {
  const { value } = props;

  const [open, setOpen] = useState(false);
  const [formDate, setFormDate] = useState("");

  const specialHours = value || {};

  const dateKeys = Object.keys(specialHours).sort();
  const displayDates = dateKeys.filter((o) => o >= moment().format("YYYY-MM-DD"));

  const handleClose = () => {
    setOpen(false);
    setFormDate("");
  };

  const handleSubmit = () => {
    if (!formDate) return;

    props.onChange({ ...specialHours, [formDate]: { pickup: [], delivery: [] } });
    handleClose();
  };

  const removeDate = (dateStr) => {
    let updated = { ...specialHours };
    delete updated[dateStr];

    props.onChange(updated);
  };

  return (
    <Box>
      <Box>
        {displayDates.map((d) => (
          <Box
            key={d}
            my={1}
            sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}
          >
            <Box>
              <Typography variant="h6" display="block" sx={{ fontWeight: "600" }}>
                {moment(d, "YYYY-MM-DD").format("LL")}
              </Typography>
              <Typography variant="body1" display="block" color="error">
                Unavailable
              </Typography>
            </Box>
            <IconButton
              size="small"
              aria-label={`Remove ${d}`}
              onClick={() => removeDate(d)}
              sx={{ flexShrink: 0 }}
            >
              <DeleteOutlineOutlinedIcon fontSize="small" />
            </IconButton>
          </Box>
        ))}
      </Box>
      <Box mt={2}>
        <Button
          fullWidth
          color="primary"
          variant="outlined"
          disableElevation
          startIcon={<AddOutlinedIcon />}
          onClick={() => setOpen(true)}
        >
          ADD NEW DATE
        </Button>
      </Box>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
            pr: 1,
          }}
        >
          Blackout Date
          <IconButton aria-label="Close" onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary">
            Customers won't be able to order this item for the selected date.
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <StaticDatePicker
              disablePast
              format="MMM d, y"
              value={formDate ? moment(formDate, "YYYY-MM-DD").toDate() : null}
              onChange={(v) => setFormDate((v && moment(v).format("YYYY-MM-DD")) || "")}
              shouldDisableDate={(d) => dateKeys.includes(moment(d).format("YYYY-MM-DD"))}
              slotProps={{
                actionBar: { actions: [] },
                toolbar: { hidden: true },
              }}
            />
          </LocalizationProvider>
        </DialogContent>
        <DialogActions sx={{ px: 2, py: 2 }}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={!formDate}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
